export default "<app-maresel-header-logo></app-maresel-header-logo>\n<app-maresel-nav-menu>\n  <ng-content></ng-content>\n</app-maresel-nav-menu>\n";